import { ManifestStore } from '../stores';
import { IManifestChangeDetection } from '../ManifestChangeDetection';
import { ManifestServiceFlags } from '../ManifestServiceFlags';
import { ManifestServiceStats } from '../ManifestServiceStats';
import { DependenciesContributor } from '../dependencies';
import type { EditorPointerServiceAPI } from '@wix/editor-document-logic-api';

export abstract class AbstractExternalAPIHandler {
  constructor(
    protected readonly dependenciesContributor: DependenciesContributor,
    protected readonly editorPointerAPI: EditorPointerServiceAPI,
    protected readonly manifestStore: ManifestStore,
    /**
     * all services bellows are used only for caching mechanism and stat collection
     */
    protected readonly manifestChangeDetection: IManifestChangeDetection,
    protected readonly manifestServiceFlags: ManifestServiceFlags,
    protected readonly manifestServiceStats: ManifestServiceStats,
  ) {}
}
